export default __webpack_public_path__ + "locales/az/JavascriptSdk.json?hash=8abf54597e2cf9d6e26435d56ace5528";